export const questions = [
    {
        id: 1,
        title: 'Who is the President of Russia?',
        options: [
            { a: 'Donald Trump', b: 'Putin', c: 'Obama', d: 'Lincoln' }
        ],
        answer: 'Putin',
        isHeld: false
    },
    {
        id: 2,
        title: 'Who invented the light Bulb?',
        options: [
            { a: 'Thomas Edison', b: 'Alexander Lodygin', c: 'Hiram Maxim', d: 'Joseph Swan' }
        ],
        answer: 'Thomas Edison',
        isHeld: false
    },
    {
        id: 3,
        title: 'Which is the most popular Js Library?',
        options: [
            { a: 'Vue', b: 'Angular', c: 'React', d: 'Jquery' }
        ],
        answer: 'React',
        isHeld: false
    },
    {
        id: 4,
        title: 'Who is the father of JavaScript?',
        options: [
            { a: 'Guido van Rossum', b: 'Brendan Eich', c: 'James Gosling', d: 'Rasmus Lerdorf' }
        ],
        answer: 'Brendan Eich',
        isHeld: false
    },
    {
        id: 5,
        title: 'Which function is used to serialize an object into a JSON string in Javascript?',
        options: [
            { a: 'parse()', b: 'convert()', c: 'stringyfy()', d: 'function()' }
        ],
        answer: 'stringyfy()',
        isHeld: false
    }
]